module.exports = __webpack_public_path__ + "img/badge_01.54ff5428.png";